import React, { useState, useRef } from "react";
import { Typography, message } from "antd";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import ReactPlayer from "react-player";
import ReactH5AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import ScormPreviewTest2 from "./legacyComp/tetsing/ScormPreviewTest2";
import { SCORM_PREVIEW } from "../config";
// import { DownloadOutlined } from "@ant-design/icons";
const { Text } = Typography;

const FilePreviewerCynter = ({
  fileUrl,
  isReadyToRender = true,
  selectedRecord,
}) => {
  const [hasError, setHasError] = useState(false);
  const [docViewerKey] = useState(Date.now());

  const fileName = fileUrl?.split("/")?.pop() || "Unknown File";
  const fileType = fileName?.split(".")?.pop()?.toUpperCase() || "N/A";
  const audioPlayerRef = useRef(null);

  // Check if URL is a Vimeo URL
  const isVimeoUrl = (url) => {
    if (!url) return false;
    return /^(https?:\/\/)?(www\.)?(vimeo\.com\/\d+|player\.vimeo\.com\/video\/\d+)/i.test(url) || /^\d+$/.test(url);
  };

  // Normalize Vimeo URL for ReactPlayer
  const normalizeVimeoUrl = (url) => {
    if (!url) return url;
    const videoId = url.match(/(?:vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)/i)?.[1] || url.match(/^(\d+)$/)?.[1] || url.match(/(\d+)/)?.[1];
    if (videoId) return `https://vimeo.com/${videoId}`;
    if (!url.startsWith("http")) return `https://${url}`;
    return url;
  };

  const videoUrl = isVimeoUrl(fileUrl) ? normalizeVimeoUrl(fileUrl) : fileUrl;

  const docs = [
    {
      uri: fileUrl,
      fileType: fileType.toLowerCase(),
      fileName,
    },
  ];
  const isVideo = ["MP4", "WEBM", "OGG"].includes(fileType) || isVimeoUrl(fileUrl);

  const isAudio = ["MP3", "WAV", "M4A", "OGG", "OGA", "AAC"].includes(fileType);
  return (
    <div
      style={{
        width: "auto", // fixed preview width
        height: "auto", // fixed preview height
        border: "1px solid #ccc",
        borderRadius: "8px",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#fff", // make sure no black background
      }}
    >
      {!hasError && fileUrl && isReadyToRender ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            overflow: "hidden", // scroll only inside
          }}
        >
          {selectedRecord?.type === "SCORM" || fileType === "XML" ? (
            <ScormPreviewTest2
              course_id={selectedRecord?.id}
              apiRoot={SCORM_PREVIEW}
              link={`${SCORM_PREVIEW}${fileUrl
                .replace(/^\//, "")
                .replace(/imsmanifest(\.xml)?$/i, "")}`}
            />
          ) : isVideo ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", minHeight: "400px" }}>
              {isVimeoUrl(fileUrl) ? (
                <iframe
                  src={`https://player.vimeo.com/video/${videoUrl.match(/\d+/)?.[0]}?controls=1&autoplay=0`}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  style={{ minHeight: "400px", border: "none" }}
                  title="Vimeo video player"
                />
              ) : (
                <ReactPlayer
                  url={videoUrl}
                  controls
                  width="100%"
                  height="100%"
                  playing={false}
                  muted={false}
                  volume={1}
                />
              )}
            </div>
          ) : isAudio ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "32px 16px",
                minHeight: "200px",
              }}
            >
              <ReactH5AudioPlayer
                ref={audioPlayerRef}
                src={fileUrl}
                autoPlay={false}
                onError={(e) => {
                  console.error("Audio error:", e);
                  message.error("Failed to play audio.");
                  setHasError(true);
                }}
                showJumpControls={false}
                style={{ width: "100%", maxWidth: 600 }}
              />
              <Text type="secondary" style={{ marginTop: 16 }}>
                Audio file: {fileName}
              </Text>
            </div>
          ) : (
            <DocViewer
              key={docViewerKey}
              documents={docs}
              pluginRenderers={DocViewerRenderers}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                },
              }}
              onDocumentLoadFailed={() => {
                setHasError(true);
                message.error("Failed to load the document.");
              }}
            />
          )}
        </div>
      ) : (
        <Text type="secondary" style={{ padding: 16 }}>
          Loading preview...
        </Text>
      )}
    </div>
  );
};

export default FilePreviewerCynter;
